import Loadable from 'react-loadable'
import Skeleton from './Skeleton'

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "overview-heading" */ './component'),
  loading: Skeleton
})
